import { useEffect } from 'react'
import { twMerge } from 'tailwind-merge'

interface OverlayProps extends React.HTMLAttributes<HTMLDivElement> {
    open: boolean
    onClose: () => void
    children: React.ReactNode
}

export function Overlay({ open, onClose, children, className, ...rest }: OverlayProps) {
    useEffect(() => {
        if (!open) return
        document.body.style.overflow = 'hidden'
        return () => {
            document.body.style.overflow = ''
        }
    }, [open])

    if (!open) return null

    return (
        <div
            className={twMerge('fixed inset-0 z-50 bg-black/80', className)}
            onClick={(e) => {
                if (e.target === e.currentTarget) onClose()
            }}
            {...rest}
        >
            {children}
        </div>
    )
}
